// Advanced Math reference sheet — quick-lookup formulas and rules, as
// opposed to the instructional walkthroughs with worked examples in the Math
// domain guide. Keep entries short: a formula or rule, not a lesson.
// Paragraphs are plain strings or structured blocks { type: 'list', ... }.

export const documentTitle = 'Advanced Math Reference';
export const documentSlug = 'advanced-math-reference';

export const parts = [
  {
    id: 'advanced-math-reference-full',
    title: null,
    sections: [
      {
        id: 'amr-exponent-rules',
        heading: 'Exponent Rules',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Product: aᵐ · aⁿ = aᵐ⁺ⁿ',
              'Quotient: aᵐ / aⁿ = aᵐ⁻ⁿ',
              'Power of a power: (aᵐ)ⁿ = aᵐⁿ',
              'Negative exponent: a⁻ⁿ = 1/aⁿ',
              'Fractional exponent: a^(1/n) is the nth root of a',
            ],
          },
        ],
      },
      {
        id: 'amr-factoring-patterns',
        heading: 'Factoring Patterns',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Difference of squares: a² - b² = (a - b)(a + b)',
              'Perfect square trinomial: a² + 2ab + b² = (a + b)²',
              'General trinomial x² + bx + c: find two numbers that multiply to c and add to b',
            ],
          },
        ],
      },
      {
        id: 'amr-quadratic-formula',
        heading: 'The Quadratic Formula',
        paragraphs: [
          'For ax² + bx + c = 0: x = (-b ± √(b² - 4ac)) / (2a).',
          {
            type: 'list',
            intro: 'The discriminant, b² - 4ac, tells you how many real solutions exist:',
            items: ['Positive: two real solutions', 'Zero: exactly one real solution', 'Negative: no real solutions'],
          },
        ],
      },
      {
        id: 'amr-functions',
        heading: 'Function Notation and Transformations',
        paragraphs: [
          {
            type: 'list',
            items: [
              'f(a) means substitute a for x in the function.',
              'f(x) + k shifts the graph up k units.',
              'f(x - h) shifts the graph right h units.',
              'Vertex form of a quadratic, y = a(x - h)² + k, has its vertex at (h, k) — a minimum if a > 0, a maximum if a < 0.',
            ],
          },
        ],
      },
      {
        id: 'amr-exponential',
        heading: 'Exponential Growth and Decay',
        paragraphs: [
          {
            type: 'list',
            items: ['Growth: y = a(1 + r)ᵗ', 'Decay: y = a(1 - r)ᵗ'],
          },
          'In both, a is the starting amount, r is the rate as a decimal, and t is the number of time periods elapsed.',
        ],
      },
    ],
  },
];
